import { Editor } from "@toast-ui/react-editor";
import { useCallback, useEffect, useMemo, useState } from "react";

interface WysiwygEditor {
  el: HTMLDivElement;
}

interface MdEditor {
  el: HTMLDivElement;
}

interface ExtendedEditorInstance extends Editor {
  wwEditor: WysiwygEditor;
  mdEditor: MdEditor;
}

interface TooltipState {
  x: number;
  y: number;
  href: string;
}
const useCustomLinkAction = (editorRef: React.RefObject<Editor>) => {
  // 상태 관리
  const [tooltipState, setTooltipState] = useState<TooltipState | null>(null);
  const [isEditorReady, setIsEditorReady] = useState(false);

  // 에디터 인스턴스 가져오기
  const editorInstance = editorRef.current?.getInstance() as unknown as ExtendedEditorInstance | undefined;
  const wysiwygElement = editorInstance?.wwEditor.el;

  // 에디터 내부 좌표 계산

  const onEditorLoad = useCallback(() => {
    setIsEditorReady(true);
  }, []);

  useEffect(() => {
    if (!wysiwygElement || !isEditorReady) return;

    const handleContainerClick = (event: MouseEvent) => {
      if (tooltipState) {
        setTooltipState(null);
      }
      const target = event.target as HTMLElement;
      const anchor = target.closest("a"); // 자식 요소(strong 등) 클릭 시에도 a 태그 탐색

      if (anchor && wysiwygElement.contains(anchor)) {
        event.preventDefault();
        event.stopPropagation(); // 에디터 기본 동작 방지

        const href = anchor.getAttribute("href");
        if (!href) return;

        const position = { x: event.clientX, y: event.clientY };
        setTooltipState({ ...position, href });
      }
    };

    /** 에디터 내장 이벤트 핸들링 간섭 방지를 위해 mouseup 이벤트 사용 */
    wysiwygElement.addEventListener("mouseup", handleContainerClick, true);
    return () => {
      wysiwygElement.removeEventListener("mouseup", handleContainerClick, true);
    };
  }, [wysiwygElement, tooltipState, isEditorReady]);

  const tooltip = useMemo(() => (tooltipState ? <Tooltip state={tooltipState} close={() => setTooltipState(null)} /> : null), [tooltipState]);

  return { tooltip, onEditorLoad };
};

export default useCustomLinkAction;

const Tooltip = ({ state, close }: { state: TooltipState; close: () => void }) => {
  return (
    <div className="editor-link-tooltip" style={{ left: state.x, top: state.y }} onClick={(e) => e.stopPropagation()}>
      <a href={state.href} target="_blank" rel="noreferrer">
        {state.href}
      </a>
      <button type="button" className="close-btn" onClick={close}></button>
    </div>
  );
};
